module.exports = __webpack_public_path__ + "img/bp.f7db638a.png";